export default {
  LIST_FETCHED: 'DONATION_ACTION_LIST_FETCHED',
  LIST_LOAD: 'DONATION_ACTION_LIST_LOAD',
  TEMPLATES_FETCHED: 'DONATION_ACTION_TEMPLATES_FETCHED',
  TEMPLATES_LOAD: 'DONATION_ACTION_TEMPLATES_LOAD',
  DETAIL_FETCHED: 'DONATION_ACTION_DETAIL_FETCHED',
  BUTTON_LOAD: 'DONATION_ACTION_BUTTON_LOAD',
};
